import React from "react";
import { cn } from "../../../lib/utils";

/** A spec-voiced empty state: one plain sentence, an optional hint and an action. */
export default function EmptyState({ title, body, action, className, testId }) {
  return (
    <div data-testid={testId} className={cn("rounded-2xl border border-eh-border-soft bg-eh-cream px-6 py-10 text-center", className)}>
      <p className="font-display text-2xl text-eh-ink">{title}</p>
      {body && <p className="mt-1 text-sm text-eh-muted">{body}</p>}
      {action && <div className="mt-4 flex justify-center">{action}</div>}
    </div>
  );
}
